<template>
    <el-card v-loading="!is_ok" class="page_card" ref="card">
        <el-form :inline="true" :model="selectForm" ref="selectForm" class="demo-form-inline">
            <el-button type="success" @click="goAddMessage" v-can="['btn:message_add']">+ 新增消息</el-button>
            <el-button plain type="danger" @click="delSelect" :loading="is_post" v-can="['btn:message_delete']" :disabled="selected.length == 0">删除</el-button>
            <el-button plain type="primary" @click="readSelect" :loading="is_post" :disabled="selected.length == 0">标为已读</el-button>
            <el-button plain type="primary" @click="readAll" :loading="is_post">全部标为已读</el-button>
            <div class="danger_text" style="margin-left: 10px;display: inline-block;font-size: 14px" v-if="un_read > 0">当前有 {{un_read}} 条信息未读!</div>
        </el-form>
        <el-table :data="data" v-loading="is_loading" empty-text="暂无消息" v-if="showtable" stripe :max-height="tableMaxHeight" @selection-change="handleSelectionChange">
            <el-table-column
                type="selection"
                width="55"
            />
            <el-table-column label="标题" width="280">
                <template slot-scope="scope">
                    <div v-if="scope.row.redirect && scope.row.redirect.length">
                        <el-link type="primary" :underline="false" @click="goTo(scope.row)">
                            <svg-icon icon-class="link" style="font-size: 1.2em" />
                            <span :class="{'text-blob':scope.row.is_read == 1}">
                                <span style="margin-left:9px;">{{scope.row.title}}</span>
                            </span>
                        </el-link>
                    </div>
                    <div v-else>
                        <span :class="{'text-blob':scope.row.is_read == 1}">
                            <svg-icon icon-class="read" v-if="scope.row.is_read == 1" style="font-size: 1.3em" />
                            <svg-icon v-else style="font-size: 1.3em" icon-class="noread" />
                            <span style="margin-left:10px;">{{scope.row.title}}</span>
                        </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="消息内容">
                <template slot-scope="scope">
                    {{scope.row.con}}
                </template>
            </el-table-column>
            <el-table-column label="接收时间" width="160">
                <template slot-scope="scope">
                    {{scope.row.addTime}}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                    <el-button size="mini" plain type="primary" @click="readOne(scope.row)" :disabled="scope.row.isRead == 1 || is_post"> <svg-icon icon-class="see" /> </el-button>
                    <el-button size="mini" plain type="danger" @click="delOne(scope.row)" :disabled="is_post"> <svg-icon icon-class="del" /> </el-button>
                </template>
            </el-table-column>
        </el-table>
        <footer style="height: 50px;position: absolute;bottom: 10px;width: calc(100% - 40px);">
            <el-pagination
                style="float: left;position: relative;top: 10px;"
                @current-change="pageChange"
                hide-on-single-page
                :current-page.sync="selectForm.pageNum"
                :page-size="selectForm.pageSize"
                layout="total,prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </footer>
        <el-dialog :visible.sync="isAddMessage" title="新增消息" width="30%">
            <el-form :model="addMessageForm" ref="addMessageForm" :rules="rules" label-width="100px">
                <el-form-item label="标题" prop="title">
                    <el-input placeholder="标题" v-model="addMessageForm.title" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                 <el-form-item label="接收人类型" prop="accept">
                    <el-checkbox-group v-model="addMessageForm.accept">
                        <el-checkbox v-for="item in accepts" :label="item.id" :value="item.id" :key="item.id">{{item.label}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <!-- <el-form-item label="推送方式" prop="pushMode">
                    <el-radio-group v-model="addMessageForm.pushMode" size="small">
                        <el-radio label="0">系统消息</el-radio>
                        <el-radio label="1">短信提醒</el-radio>
                    </el-radio-group>
                </el-form-item> -->
                <el-form-item label="定时发送" prop="sendTime">
                    <el-date-picker
                        v-model="addMessageForm.sendTime"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm:ss"
                        style="width: 100%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="请选择时间">
                    </el-date-picker>
                </el-form-item>
                 <el-form-item label="消息内容" prop="content">
                    <el-input placeholder="消息内容" v-model="addMessageForm.content" :autosize="{ minRows: 5, maxRows:10}" maxlength="200" show-word-limit type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="" class="flex">
                    <el-button plain type="primary" @click="addSubmit" :loading="is_post">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </el-card>
</template>

<script>
import request from '@/utils/request'
import can from "@/directive/can/index.js"
import { parseTime,formatTime } from '@/utils'
import { mapGetters } from 'vuex'


export default {
    name: 'account_message',
    directives:{can},
    data(){
        return {
            is_ok:false,
            isAddMessage:false,
            is_post:false,
            is_loading:false,
            showtable:false,
            data:[
                // {title:"这是一个测试消息",con:"这是一个消息的内容 balabaldaldkfjaksdjfkajdkfj!",add_time:1620715692,status:1,is_read:1,redirect:""},
                // {title:"这是一个链接消息",con:"点击跳到我的资料!!",add_time:1620438104,status:1,is_read:1,redirect:"/account/basic"},
            ],
            tableMaxHeight:0,
            current:1,
            selectForm:{
                pageNum:1,
                pageSize:15
            },
            selected:[],
            un_read:0,
            total:0,
            accepts:[
                {id:0,label:"系统用户"},
                {id:1,label:"驾驶员"},
                {id:2,label:"企业用户"}
            ],
            addMessageForm:{
                title:"",
                accept:[],
                // pushMode:'0',
                sendTime:"",
                content:'',
            },
            rules:{
                title:[
                    { required: true, message: '请输入标题', trigger: 'blur' },
                ],
                accept:[
                    { required: true, message: '请选择接收人类型', trigger: 'blur' },
                ]
            },
        }
    },
    computed:{
        ...mapGetters([
            'message',
            'roles',
            'message_total'
        ])
    },
    methods:{
        goAddMessage(){
            this.isAddMessage=true;
        },
        pageChange(page){
            this.selectForm.pageNum = page;
            this.getData(page);
        },
        handleSelectionChange(val) {
            this.selected = val;
        },
        formatTime(time){
            return formatTime(time,"{y}-{m}-{d} {h}:{i}:{s}");
        },
        goTo(item){
            this.$router.push({path:item.redirect});
        },
        delOne(item){
            this.is_post = true;
            request.post("message/delete",{ids:[item.id]}).then(res=>{
                this.$message.success("消息删除成功");
                this.un_read = res.data;
                for(let i =0;i<this.data.length;i++){
                    if(this.data[i].id == item.id){
                        this.data.splice(i,1);
                    }
                }
                this.$bus.emit("nav_msg_change");
                this.is_post = false;
            }).catch(err=>{
                this.is_post = false;
            });
        },
        readOne(item){
            this.is_post = true;
            request.post("message/read",{ids:[item.id]}).then(res=>{
                this.un_read = res.data;
                this.$bus.emit("nav_msg_change");
                this.un_read = res.data;
                item.isRead = 1;
                this.is_post = false;
            }).catch(err=>{
                this.is_post = false;
            });
        },
        readAll(){
            this.$confirm('此操作将您的所有消息改为已读状态, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                this.is_post = true;
                request.get("message/read_all").then(res=>{
                    for(let item of this.data){
                        item.isRead = 1;
                    }
                    this.un_read = res.data;
                    this.$bus.emit("nav_msg_change");
                    this.$message.success("所有消息已改为已读状态");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        delSelect(){
            this.$confirm('此操作将永久删除选中消息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let arr = [];
                for(let item of this.selected){
                    arr.push(item.id);
                }
                this.is_post = true;
                request.post("message/delete",{ids:arr}).then(res=>{
                    this.$message.success("消息删除成功");
                    this.un_read = res.data;
                    this.getData();
                    this.$bus.emit("nav_msg_change");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        readSelect(){
            let arr = [];
            for(let item of this.selected){
                arr.push(item.id);
            }
            this.is_post = true;
            request.post("message/read",{ids:arr}).then(res=>{
                for(let item of this.data){
                    if(arr.some(id=>item.id == id)){
                        item.isRead = 1;
                    }
                }
                this.un_read = res.data;
                this.$bus.emit("nav_msg_change");
                this.$message.success("选中消息已改为已读状态");
                this.is_post = false;
            }).catch(err=>{
                this.is_post = false;
            });
        },
        addSubmit(){
            this.$refs["addMessageForm"].validate(valid=>{
                if(!valid) return false;
                request.post("message/add",this.addMessageForm).then(res=>{
                    this.isAddMessage = false;
                    this.addMessageForm={
                        title:"",
                        accept:[],
                        // pushMode:'0',
                        sendTime:"",
                        content:'',
                    },
                    this.$refs["addMessageForm"].resetFields();
                    this.getData();
                    this.$message.success("新增消息成功!");
                }).catch(err=>{
                });
            })
        },
        getData(page = 1,is_init = false){
            if(!is_init){
                this.is_loading = true;
                this.is_post = true;
            }
            request.post("message/list",this.selectForm).then(res=>{
                this.data = res.data.data.list;
                this.total = res.data.data.total;
                this.un_read = res.data.unread;
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
                this.showtable = true;
                if(is_init){
                    this.is_ok = true;
                }else{
                    this.is_post = false;
                    this.is_loading = false;
                }
            }).catch(err=>{
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
                this.showtable = true;
                if(is_init){
                    this.is_ok = true;
                }else{
                    this.is_post = false;
                    this.is_loading = false;
                }
            });
        },
        readall_submit(){
            for(let item of this.data){
                item.isRead = 1;
            }
        }
    },
    created(){
        this.$bus.on("msg_read_all",this.readall_submit);
    },
    mounted(){
        this.getData(1,true);
    },
    beforeDestroy() {
        this.$bus.off("msg_read_all");
    }
}
</script>

<style scoped lang="scss">
.text-blob{
    font-weight: bold;
}
.flex{
    display: flex;
    justify-content:center;
    margin-right: 100px;
}
</style>
